// test1151
(1151 && 0);
